<template>
  <div class="defaultHeader">
    <!-- <div class="defaultHeader__bg"></div> -->
    <div class="defaultHeader__bg-white"></div>
    <router-link to="/" style="width: 70%; margin: auto;">
      <img class="defaultHeader__logo" src="@/assets/exide-logo-black.svg" alt="Exide" />
    </router-link>
    <h2>{{ h2 }}</h2>
  </div>
</template>

<script>
module.exports = {
  props: ['h2'],
  name: 'DefaultHeader',
  data() {
    return {
      currentPage: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(from);
    });
  },
  methods: {
    checkIfShouldBackbtn() {
      this.currentPage = this.$router.history.current.name;
      if (
        (this.currentPage && this.currentPage == 'ClientsList') ||
        this.currentPage == 'Dashboard'
      ) {
        return false;
      }

      return true;
    },
    goToPreviousPage() {
      this.$router.go(-1);
    }
  }
};
</script>

